module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "hidden-ios-true hidden-android-true"
  }, [_c('v-card-text', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Get the app")])]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subheading"
  }, [_vm._v("Download the AppointmentGuru app on your phone so you can manage everything on the go!")]), _vm._v(" "), (_vm.installer) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.installMobile
    }
  }, [_vm._v("Install on this device")]) : _vm._e(), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("To install on iOS: ")]), _vm._v(" "), _c('li', [_vm._v("Click on the share icon "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("ios_share")])], 1), _vm._v(" "), _c('li', [_vm._v("Scroll and click on \"add to home screen\"")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "overline pl-0"
  }, [_vm._v("To install on Android: ")]), _vm._v(" "), _c('p', [_vm._v("If you visit\n        "), _c('a', {
    attrs: {
      "href": "https://app.appointmentguru.co"
    }
  }, [_vm._v("app.appointmentguru.co")]), _vm._v("\n        you should be prompted to install the app\n      ")]), _vm._v(" "), _c('strong', {
    staticClass: "overline"
  }, [_vm._v("If not, try this:")]), _vm._v(" "), _c('li', [_vm._v("Click on the three dots (top right in Chrome)")]), _vm._v(" "), _c('li', [_vm._v("Click on \"Install app\"")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-3"
  }, [_c('v-card-text', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Calender")]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("Use the address below to sync your AppointmentGuru calendar to your phone calendar app.")])]), _vm._v(" "), _c('v-card-text', [_c('copy-text-field', {
    attrs: {
      "label": "Your calendar address",
      "hint": "Add your calendar feed to pull your AppointmentGuru appointments into your calendar of choice",
      "text-to-copy": _vm.feedUrl
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "href": "https://appointmentguru.co/help/sync-to-a-phone-calendar-app/",
      "target": "_blank"
    }
  }, [_vm._v("More info "), _c('v-icon', [_vm._v("open_in_new")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637d8f20","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/Calendar.vue
// module id = 1446
// module chunks = 9